import React, { useState } from 'react'
import { Box, Modal, } from '@mui/material';
import details from '../container/courses/details.module.css'
import VimeoPlayer from './VimeoPlayer'

const VideoModal = ({
    closeModal,
    open,
    video,
    title,
    thumbnail
}) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const handlePlay = () => {
        setIsPlaying(true);
    };


    const styles = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "transparent",
        border: "none",
        height: "100%",
        display: "block",
        width: '100%',
        borderRadius: '7px',
        "&:focus": {
            outline: "none",
        },
    };


    return (
        <Modal
            open={open}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styles}>
                <div className={details.modalContainer}>
                    <div className={details.videoThumbnail}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p className={details.previewText}>Course Preview</p>
                            <img src="/cross.svg" alt="" onClick={closeModal} style={{ width: 18, cursor: "pointer" }} />
                        </div>
                        <p className={details.titleText}>{title}</p>
                        {isPlaying ? (
                            <VimeoPlayer
                                className={details.videoPlayer}
                                src={typeof video === "string" ? video : video?.url}
                                title="Video"
                            />
                        ) : (
                            <img
                                src={thumbnail} // Replace with your video thumbnail
                                alt="Video Thumbnail"
                                className={details.thumbnailImage}
                            />
                        )}
                        {!isPlaying && (
                            <button className={details.playbutton} onClick={handlePlay}>
                                &#9658;
                            </button>
                        )}
                    </div>
                </div>
            </Box>
        </Modal>
    )
}

export default VideoModal